import Highlight from 'components/Highlight';

const MAX_LENGTH = 60;
const TRUNCATED_TEXT_CLASS = 'truncated-text';
const TRUNCATION_SUFFIX = '…';
const EMPTY_VALUE_PLACEHOLDER = '-';

/**
 * Renders free text cut to MAX_LENGTH characters with the full value kept in
 * the title attribute for hover. The active search term is marked inside the
 * visible portion only; Highlight no-ops when substring is empty or undefined,
 * so the rendering with no active search is unchanged.
 */
function TruncatedText(props) {
	const { text, searchString } = props;

	if (!text) {
		return <span className={TRUNCATED_TEXT_CLASS}>{EMPTY_VALUE_PLACEHOLDER}</span>;
	}
	if (text.length <= MAX_LENGTH) {
		return (
			<span className={TRUNCATED_TEXT_CLASS}>
				<Highlight text={text} substring={searchString} />
			</span>
		);
	}

	return (
		<span className={TRUNCATED_TEXT_CLASS} title={text}>
			<Highlight text={text.slice(0, MAX_LENGTH)} substring={searchString} />{TRUNCATION_SUFFIX}
		</span>
	);
}

export default TruncatedText;
